<template>
  <div>
  <section>
			<div class="container">
				<figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
			</div>
		</section>
        <section>
            <div class="container">
                <ol class="breadcrumb hidden-xs">
                    <li><a href="/">首頁</a></li>
                    <li><a href="/member">會員中心</a></li>
                    <li class="active">註冊</li>
                </ol>
                <div class="row">
                    <div class="col-sm-offset-3 col-sm-6">
                        <h4 class="text-center">會員註冊</h4>
                        <div class="register_form">
                            <form class="form-horizontal">
                                <div class="form-group">
                                    <label for="account" class="col-sm-3 control-label">*帳號(Email)</label>
                                    <div class="col-sm-6">
                                    <input type="email" class="form-control" v-model="account" placeholder="請勿輸入特殊符號 如:&*_#等符號">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="password" class="col-sm-3 control-label">*設定密碼</label>
                                    <div class="col-sm-6">
                                      <input :type="passwordType ? 'password' : 'text'" class="form-control" v-model="password" id="password" placeholder="密碼">
                                      <input type="checkbox" :checked="displaypwd" @click="onChange($event)"/> 顯示密碼
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="password" class="col-sm-3 control-label">*再次輸入密碼</label>
                                    <div class="col-sm-6">
                                      <input type="password" class="form-control" v-model="doublepassword" id="doublepassword" placeholder="再次輸入密碼">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="name" class="col-sm-3 control-label">*姓名</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="請填寫中文本名">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="phone" class="col-sm-3 control-label">*行動電話</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" maxlength="10" v-model="phone" id="phone" placeholder="行動電話">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="idno" class="col-sm-3 control-label">*身分證字號</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" maxlength="10" v-model="identify" id="idno" placeholder="身分證字號">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="address" class="col-sm-3 control-label">地址</label>
                                    <div class="col-sm-4">
                                        <select class="form-control" v-model="countyval">
                                            <option v-for="option in county" v-bind:value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4">
                                        <select class="form-control" v-model="districtval">
                                            <option v-for="option in district" v-bind:value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="address" class="col-sm-3 control-label"></label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="address">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="phone" class="col-sm-3 control-label">推薦人編號</label>
                                    <div class="col-sm-6">
                                        <input type="number" class="form-control" v-model="parentid" :disabled="validated == 1" id="parentid" placeholder="推薦人編號">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-offset-3 col-sm-9">
                                        <div class="checkbox">
                                            <label>
                                                <input type="checkbox" value="1" v-model="member_policy"/>
                                                我同意<a href="/member_policy" target="_blink">遵守「會員條款」之內容</a>
                                            </label>
                                            <label>
                                                <input type="checkbox" value="1" v-model="agreement"/>
                                                我同意<a href="/privacy" target="_blink">「隱私權政策」之內容</a>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">

                                    <div class="col-sm-offset-3 col-sm-9">
                                        <pulse-loader :loading="loading" ></pulse-loader>
                                        <button type="button" class="btn btn-default" @click="register()" :disabled="this.flag">註冊</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
  name: 'Register',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      rowData: {},
      agreement: true,
      member_policy: true,
      account: '',
      password: '',
      doublepassword: '',
      name: '',
      phone: '',
      parentid: '',
      identify: '',
      countyval: '',
      districtval: '',
      county: this.$store.getters.getCounty,
      district: [],
      address: '',
      validated: 0,
      flag: false,
      loading: false,
      displaypwd: false,
      passwordType: true
    }
  },
  components: {
    PulseLoader
  },
  mounted: function () {
    let parentID = this.$route.params.id
    if (parentID) {
      this.parentid = parentID
      localStorage.setItem('shareid', parentID)
    } else {
      this.parentid = localStorage.getItem('shareid')
    }
    if (this.parentid) {
      this.validated = 1
    }
  },
  methods: {
    ...mapActions([
      'getShareid'
    ]),
    onChange () {
      this.displaypwd = true
      if (this.passwordType === true) {
        this.passwordType = false
      } else {
        this.passwordType = true
      }
    },
    register () {
      try {
        /*eslint-disable */
        let email = this.account.toLowerCase()
        let str = ''
        if (this.name === '') {
          str += '請填寫個人姓名。\n'
        } else if (email === '' || !email) {
          str += '請輸入您的 Email\n'
        } else if (this.password === '' || !this.password) {
          str += '請輸入您的密碼\n'
        } else if (this.phone === '' || !this.phone) {
          str += '請輸入您的聯絡電話\n'
        } else if (this.identify === '' || !this.identify) {
          str += '請輸入您的身分證字號\n'
        } else if (!this.agreement) {
          str += '請勾選同意隱私權政策。\n'
        } else if (!this.member_policy) {
          str += '請勾選同意會員條款。\n'
        }

        const rulename = new RegExp('^[\u4e00-\u9fa5_a-zA-Z]+$')
        if (!rulename.test(this.name)) {
          str += '您的姓名只能輸入中文或英文。\n'
        }

        const ruleemail = new RegExp('^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$')
        if (!ruleemail.test(email)) {
          str += '您輸入 Email 格式不正確。\n'
        }

        let identifyId = this.identify
        const rule = new RegExp('^[A-Za-z]{1,2}[1-2]{1}[0-9]{7,8}$')
        if (!rule.test(identifyId)) {
          str += '您輸入身分證字號長度不正確。\n'
        }

        let conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
        let weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]

        identifyId = String(conver.indexOf(identifyId[0]) + 10) + identifyId.slice(1);

        let checkSum = 0
        for (let i = 0; i < identifyId.length; i++) {
            let c = parseInt(identifyId[i])
            let w = weights[i]
            checkSum += c * w
        }
        if (checkSum % 10 !== 0) {
          str += '您輸入身分證字號不合法。\n'
        }

        const rulep = new RegExp('^[09]{2}[0-9]{8}$')
        if (!rulep.test(this.phone)) {
          str += '您輸入的手機格式不正確。\n'
        }

        const password_rule = new RegExp('^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,20}$');
        if (!password_rule.test(this.password)) {
          str += '密碼格式不符，至少超過 6 碼，且包含數字及大小寫英文\n'
        }
        if (this.password !== this.doublepassword) {
          str += '您兩次輸入的密碼不正確。\n'
        }
        /*
        if (this.countyval === '' || this.districtval === '') {
          str += '請選擇縣市及區域\n'
        }
        if (this.address === '') {
          str += '請填寫地址\n'
        }
        */
        if (str === '' && this.flag === false) {
          this.loading = true
          this.flag = true
          this.$http.post(this.apiurl + 'api/register', {
            email: email,
            org_account: this.account,
            password: this.password,
            org_cellphone: this.phone,
            parent_id: this.parentid,
            org_name: this.name,
            org_identify: this.identify.toUpperCase(),
            org_country: this.countyval,
            org_town: this.districtval,
            org_address: this.address,
            user_agent: navigator.userAgent,
            org_from: 'website'
          }).then(function (res) {
            console.log(res)
            this.loading = false
            let response = res.body
            let id = response.id
            if (response.status !== 503) {
              window.alert('註冊成功，您的編號為:' + id)
              this.$router.go('/')
            } else {
              window.alert('註冊失敗，此組『信箱』或『身份證』，已註冊過帳號。')
              this.flag = false
            }
          }, function () {
            console.log('failed')
          })
        } else {
          window.alert(str)
        }
      } catch (error) {
				window.alert(error)
			}
    }
  },
  computed: {
    ...mapGetters([
      'getCounty'
    ])
  },
  watch: {
    countyval: {
      handler: function (val, oldVal) {
        let key = parseInt(val) - 1
        let district = this.$store.getters.getDistrict
        this.district = district[key]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register.vue?0d4c0acd